import React, { createContext, useContext, useState, ReactNode } from "react";

interface GeofenceData {
    geofenceName: string;
    geofenceCode: string;
    address: string;
    latitude: string;
    longitude: string;
    shape: string;
    radius: number | string;
    geofenceCategory: string;
    polyData: any[];
    tags: string;
    group: string;
}

interface GeofenceContextProps {
  geofenceData: GeofenceData;
  isGeofenceDataSaved: boolean;
  setGeofenceData: React.Dispatch<React.SetStateAction<GeofenceData>>;
  setIsGeofenceDataSaved: React.Dispatch<React.SetStateAction<boolean>>;
}

const defaultGeofenceData: GeofenceData = {
  geofenceName: "",
  geofenceCode: "",
  address: "",
  latitude: "",
  longitude: "",
  shape: "",
  radius: "",
  geofenceCategory: "",
  tags: "",
  group: "",
  polyData: [],
};

const GeofenceContext = createContext<GeofenceContextProps | undefined>(undefined);

export const GeofenceProvider = ({ children }: { children: ReactNode }) => {
  const [geofenceData, setGeofenceData] = useState<GeofenceData>(defaultGeofenceData);
  const [isGeofenceDataSaved, setIsGeofenceDataSaved] = useState<boolean>(false);

  return (
    <GeofenceContext.Provider
      value={{ geofenceData, setGeofenceData, isGeofenceDataSaved, setIsGeofenceDataSaved }}
    >
      {children}
    </GeofenceContext.Provider>
  );
};

export const useGeofenceContext = () => {
  const context = useContext(GeofenceContext);
  if (!context) {
    throw new Error("useGeofenceContext must be used within a GeofenceProvider");
  }
  return context;
};
